import React from 'react'
import Logo from '../assets/logo.png';
import 'animate.css';

const SplashScreen = () => {
    return (
        <>
            <section className='my-5 text-center py-5'>
                <div className='container py-5'>

                    <img src={Logo} className='img-fluid my-4 animate__animated animate__zoomIn' alt='Splash Logo' />
                    <p className='fw-bold fs-1 animate__animated animate__fadeInUp' style={{ color: 'var(--green)' }}>"सफर आपका, साथ हमारा"</p>

                </div>
            </section>
        </>
    )
}

export default SplashScreen
